export type BannerType = {
  [val: number]: {
    type: BANNER_MESSAGE_TYPE;
    text: string;
  };
};

export enum BANNER_MESSAGE_TYPE {
  SUCCESS,
  CAUTION,
  FAIL,
  FAIL_400,
}

export enum BANNER_TYPE {
  //SUCCESS
  DOWNLOAD_SUCCESSFUL,
  API_SUCCESS,
  LABEL_PRINTED,

  //CAUTION
  NO_DATA_AVAILABLE,
  RESULTS_FROM_UPLOAD,

  //COMMON ERRORS
  API_UNAUTHORIZED,
  API_ERROR,
  API_400_ERROR,
  API_FORBIDDEN,
  API_NOT_FOUND,
  DOWNLOAD_UNSUCCESSFUL,
  TABLE_DATA_ERROR,
  ROUTES_ERROR,
  COUNTRY_ERROR,
  LOCATION_PROFILE_ERROR,
  GROUP_LINKED_SITES_ERROR,
  LOCATION_GROUPS_ERROR,
  ROUTE_SUMMARY_ERROR,
  NO_LOCATIONS,
  CANNOT_FIND_ROUTE,

  //CURRENT USER ERRORS
  GET_CURRENT_USER_ERROR,
  EMPLOYEE_ID_LOGIN_ERROR,
  ROLES_UNSUCCESSFUL,
  CURRENT_USER_LINKED_SITES_ERROR,
  CURRENT_USER_LOCATION_GROUP_ERROR,

  //EXCEPTIONS PAGE
  EXCEPTION_EVENT_TYPES_ERROR,
  EXCEPTION_REASONS_ERROR,
  EXCEPTION_RESOLUTION_ERROR,
  EXCEPTION_STATUSES_ERROR,
  EXCEPTION_VALIDATE_ERROR,
  EXCEPTION_SERVICE_LEVELS_ERROR,
  DDO_ERROR,

  //VARIOUS OTHER ERRORS
  ROUTE_EXISTS,
  TIMEZONE_ERROR,
  UAP_LOCATION_ERROR,
  REPORTS_REFERENCE_NUMBER_ERROR,
  PACKAGE_DETAILS_ERROR,
  PACKAGE_HISTORY_ERROR,
  LOCATION_BREAK_DURATION_ERROR,

  // INCORRECT ADDRESS
  INCORRECT_CUST_NAME,
  INCORRECT_STREET_NAME,
  INCORRECT_STREET_NUMBER,
  INCORRECT_STREET_PREFIX,
  INCORRECT_STREET_SUFFIX,
  INCORRECT_STREET_TYPE,
  INCORRECT_SUITE,
  INCORRECT_FLOOR,
  INCORRECT_MUNIC,
  INCORRECT_BARRIO,
  INCORRECT_ZIP,
  INCORRECT_POSTAL_CODE,
  INCORRECT_STATE,
  INCORRECT_ADDRESS,
}

const SUCCESS_BANNERS: BannerType = {
  [BANNER_TYPE.DOWNLOAD_SUCCESSFUL]: {
    type: BANNER_MESSAGE_TYPE.SUCCESS,
    text: $localize`File Successfully Downloaded`,
  },
  [BANNER_TYPE.API_SUCCESS]: {
    type: BANNER_MESSAGE_TYPE.SUCCESS,
    text: $localize`Operation Successful`,
  },
  [BANNER_TYPE.LABEL_PRINTED]: {
    type: BANNER_MESSAGE_TYPE.SUCCESS,
    text: $localize`Shipping Label Download Successful`,
  },
};

const CAUTION_ERRORS: BannerType = {
  [BANNER_TYPE.NO_DATA_AVAILABLE]: {
    type: BANNER_MESSAGE_TYPE.CAUTION,
    text: $localize`No Data Available`,
  },
  [BANNER_TYPE.RESULTS_FROM_UPLOAD]: {
    type: BANNER_MESSAGE_TYPE.CAUTION,
    text: $localize`Results from Upload`,
  },
};

const OPERATIONS_INCORRECT_ADDRESS: BannerType = {
  [BANNER_TYPE.INCORRECT_POSTAL_CODE]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Postal Code`,
  },
  [BANNER_TYPE.INCORRECT_STATE]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid State or Province`,
  },
  [BANNER_TYPE.INCORRECT_CUST_NAME]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Customer Name`,
  },
  [BANNER_TYPE.INCORRECT_FLOOR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Floor`,
  },
  [BANNER_TYPE.INCORRECT_MUNIC]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Municipality`,
  },
  [BANNER_TYPE.INCORRECT_BARRIO]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Municipality`,
  },
  [BANNER_TYPE.INCORRECT_STREET_NAME]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Street Name`,
  },
  [BANNER_TYPE.INCORRECT_STREET_NUMBER]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Street Number`,
  },
  [BANNER_TYPE.INCORRECT_STREET_PREFIX]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Street Prefix`,
  },
  [BANNER_TYPE.INCORRECT_STREET_SUFFIX]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Street Suffix`,
  },
  [BANNER_TYPE.INCORRECT_STREET_TYPE]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Street Type`,
  },
  [BANNER_TYPE.INCORRECT_SUITE]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Suite`,
  },
  [BANNER_TYPE.INCORRECT_ADDRESS]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Invalid Address`,
  },
};

const COMMON_ERRORS: BannerType = {
  [BANNER_TYPE.DOWNLOAD_UNSUCCESSFUL]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Download Unsuccessful`,
  },
  [BANNER_TYPE.API_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Something Went Wrong!`,
  },
  [BANNER_TYPE.API_400_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL_400,
    text: $localize`Error - %s`,
  },
  [BANNER_TYPE.API_UNAUTHORIZED]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Not Authorized`,
  },
  [BANNER_TYPE.API_FORBIDDEN]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Forbidden`,
  },
  [BANNER_TYPE.API_NOT_FOUND]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - API Not Found`,
  },
  [BANNER_TYPE.ROUTES_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get list of valid routes`,
  },
  [BANNER_TYPE.TABLE_DATA_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get table data`,
  },
  [BANNER_TYPE.COUNTRY_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Cannot not get available countries`,
  },
  [BANNER_TYPE.LOCATION_PROFILE_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get profile information for selected location`,
  },
  [BANNER_TYPE.GROUP_LINKED_SITES_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get linked sites for location`,
  },
  [BANNER_TYPE.LOCATION_GROUPS_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get list of available location groups`,
  },
  [BANNER_TYPE.ROUTE_SUMMARY_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get route summary data`,
  },
  [BANNER_TYPE.NO_LOCATIONS]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - No locations associated with chosen group!`,
  },
  [BANNER_TYPE.CANNOT_FIND_ROUTE]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not find newly created stop to complete!  Please reload the page and manually complete the stop.`,
  },
};

const CURRENT_USER_ERRORS: BannerType = {
  [BANNER_TYPE.GET_CURRENT_USER_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get your user profile`,
  },
  [BANNER_TYPE.EMPLOYEE_ID_LOGIN_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Please log in using Employee ID option`,
  },
  [BANNER_TYPE.CURRENT_USER_LINKED_SITES_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve your list of available locations`,
  },
  [BANNER_TYPE.CURRENT_USER_LOCATION_GROUP_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve your list of available location groups`,
  },
  [BANNER_TYPE.ROLES_UNSUCCESSFUL]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Cannot get roles available for this user`,
  },
};

const EXCEPTIONS_SCREEN_ERRORS: BannerType = {
  [BANNER_TYPE.EXCEPTION_EVENT_TYPES_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve the available exception event types`,
  },
  [BANNER_TYPE.EXCEPTION_REASONS_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve the available exception reasons`,
  },
  [BANNER_TYPE.EXCEPTION_RESOLUTION_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve the available exception resolutions`,
  },
  [BANNER_TYPE.EXCEPTION_STATUSES_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve the available exception statuses`,
  },
  [BANNER_TYPE.EXCEPTION_VALIDATE_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not validate information provided`,
  },
  [BANNER_TYPE.EXCEPTION_SERVICE_LEVELS_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get available service levels`,
  },
  [BANNER_TYPE.DDO_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Address Corrections not allowed for DDO Packages`,
  },
};

export const BANNER: BannerType = {
  ...SUCCESS_BANNERS,
  ...COMMON_ERRORS,
  ...CAUTION_ERRORS,
  ...CURRENT_USER_ERRORS,
  ...EXCEPTIONS_SCREEN_ERRORS,
  ...OPERATIONS_INCORRECT_ADDRESS,
  [BANNER_TYPE.ROUTE_EXISTS]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Route Id Already Exists`,
  },
  [BANNER_TYPE.TIMEZONE_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get available timezones`,
  },
  [BANNER_TYPE.UAP_LOCATION_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get list of available UAP locations`,
  },
  [BANNER_TYPE.REPORTS_REFERENCE_NUMBER_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not get list of reference numbers`,
  },
  [BANNER_TYPE.PACKAGE_DETAILS_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve the details for the provided tracking number`,
  },
  [BANNER_TYPE.PACKAGE_HISTORY_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Could not retrieve the history for the provided tracking number`,
  },
  [BANNER_TYPE.LOCATION_BREAK_DURATION_ERROR]: {
    type: BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Break Duration cannot exceed time between Break Start and End`,
  },
};

export const FILE_UPLOAD_RESPONSE = {
  BUILDING_SCANS: $localize`Building Scans`,
  PACKAGES: $localize`Packages`,
  STOPS: $localize`Stops`,
  ACCEPTED: $localize`accepted`,
  REJECTED: $localize`rejected`,
  INVALID: $localize`Invalid Lines`,
  NUMBER_OF_ROWS: $localize`Number of rows in uploaded file`,
  DEVICE_NAME: $localize`Device Name`,
};
